interface AccessRestrictedPageProps {
  title: string;
  message: string;
}

const AccessRestrictedPage = ({
  title,
  message,
}: AccessRestrictedPageProps) => {
  return (
    <div className="flex-1 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
      </div>

      <div className="rounded-xl border border-amber-200 bg-amber-50 p-6 text-amber-900 shadow-sm">
        <h2 className="text-lg font-semibold">Acesso restrito</h2>
        <p className="mt-2 text-sm leading-6">{message}</p>
      </div>
    </div>
  );
};

export default AccessRestrictedPage;
